export const LEGACY_ENDPOINT_RETIREMENT_DATE = {
  iso: '2026-10-15',
  label: 'October 15, 2026',
} as const
